import { Alert, Box, Button, Typography } from '@mui/material';
import { Navigate } from 'react-router-dom';
import { ANALYTICS_URL, canAccessAnalytics } from '../../config/analytics';
import { getLoggedInUser } from '../../utils/permissions';

export default function AnalyticsPage() {
  if (!canAccessAnalytics(getLoggedInUser())) {
    return <Navigate to="/" replace />;
  }

  const isMixedContent = window.location.protocol === 'https:' && ANALYTICS_URL.startsWith('http:');

  return (
    <Box component="main" sx={{ ml: { md: '240px' }, mt: '64px', p: 2, height: 'calc(100dvh - 64px)', boxSizing: 'border-box', display: 'flex', flexDirection: 'column', gap: 2 }}>
      {/* <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
        <Typography variant="h5" component="h1">Analytics</Typography>
        <Button component="a" href={ANALYTICS_URL} target="_blank" rel="noopener noreferrer">Open in new tab</Button>
      </Box> */}
      {isMixedContent ? (
        <Alert severity="warning">
          Analytics cannot be embedded in this secure page until its URL supports HTTPS. Use “Open in new tab” to view it.
        </Alert>
      ) : (
        <Box component="iframe" title="Analytics dashboard" src={ANALYTICS_URL} referrerPolicy="no-referrer" sx={{ flex: 1, minHeight: 0, width: '100%', border: 0, borderRadius: 2, bgcolor: 'white' }} />
      )}
    </Box>
  );
}
